<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Affiliate Rate Issues' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()" [notify]="notifyObj"></app-page-header>

    <div class="row center">
        <!-- stat panel -->
        <div class="col-md-12 pt-3" *ngIf="vm.statPanelVm as svm">
            <mdb-card narrower="true" cascade="true">
                <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
                <mdb-card-body cascade="true">
                    <div class="row">
                        <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-9"><strong>{{s.statName}}:</strong></div>
                                    <div class="col-md-3 px-0">
                                        <button *ngIf="currentPage != s.stringValue" style="margin-top: -5px;" mdbBtn type="button" color="info"
                                            rounded="true" outline="true" size="sm" mdbWavesEffect class="btn-block"
                                            (click)="showData(vm, s.stringValue)">
                                            {{s.intValue}}
                                        </button>

                                        <button *ngIf="currentPage == s.stringValue" style="margin-top: -5px;" mdbBtn type="button" color="unique"
                                            rounded="true" outline="true" size="sm" mdbWavesEffect class="btn-block"
                                            (click)="showData(vm, s.stringValue)">
                                            {{s.intValue}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>

    <div *ngIf="commingSoon">
        <div class="row pt-4 px-5">
            <blockquote class="blockquote bq-primary">
                <p class="bq-title">Comming Soon...</p>
            </blockquote>
        </div>
    </div>
    <div *ngIf="!commingSoon">
        <div *ngIf="vm.affRateIssuePanelVm as ari">
            <div *ngIf="ari.instructions" class="row pt-4 px-5">
                <blockquote class="blockquote bq-primary">
                    <p class="bq-title">Instructions</p>
                    <p>{{ari.instructions}}</p>
                </blockquote>
            </div>
            <div class="col-md-12 pt-3">
                <app-data-table-pagination [vm]="ari"></app-data-table-pagination>
            </div>
        </div>
    </div>
</div>